import { buildEntitySheet, SheetContact } from './entitySheetPdfLayout';

interface ExtrasPartnerPdfData {
    id: string;
    name: string;
    email?: string;
    phone?: string;
    address?: string;
    notes?: string;
    contact?: SheetContact;
    logoUrl?: string | null;
    types?: string[];
    issuerName?: string;
    brandColor?: string;
}

// Fiche partenaire (module Extras). Toute la mise en page vit dans entitySheetPdfLayout — reprise du modèle
// fourni par Emeni (2026-08-24) — et ce fichier ne décrit plus que ce qui distingue un partenaire d'un
// fournisseur : son catalogue est une liste de TYPES d'extras, sans prix (ils n'en ont pas), rendue en
// pastilles comme sur le modèle.
export const generateExtrasPartnerPdf = async (data: ExtrasPartnerPdfData) => {
    try {
        const doc = await buildEntitySheet({
            id: data.id,
            kindLabel: 'Fiche partenaire',
            name: data.name,
            email: data.email,
            phone: data.phone,
            address: data.address,
            notes: data.notes,
            contact: data.contact,
            logoUrl: data.logoUrl,
            issuerName: data.issuerName,
            brandColor: data.brandColor,
            sections: [{
                title: "Catalogue de types d'extras",
                rows: (data.types || []).map((label) => ({ left: label })),
                emptyLabel: "Aucun type d'extra renseigné pour ce partenaire.",
                asChips: true,
            }],
        });
        const cleanName = data.name.replace(/[^a-zA-Z0-9]/g, '_');
        doc.save(`Partenaire_${cleanName}.pdf`);
    } catch (e) {
        console.error('Extras Partner PDF Generation Error:', e);
        alert('Erreur lors de la génération du document PDF.');
    }
};
